import inst from '@/backend/axios-instances'

const instance = inst.baseInstance
const resource = '/permission'

export default {
  put(policyId, data, parameters) {
    return instance.put(`${resource}/${policyId}`, data, { params: parameters });
  },
  delete(policyId) {
    return instance.delete(`${resource}/${policyId}`);
  },
  putUserPolicy(policyId, data) {
    return instance.post(`${resource}/${policyId}/users`, data);
  }
}